// "Nb établissements" buckets — the founder/dirigeant group-size filter.
//
// Shared by the establishment database (`nbEtablissements` param), the signal folders
// (`founderEstablishmentsCount` param) and SignalTable, which needs the ranges to work out
// WHICH of an establishment's dirigeants the backend matched on. The bounds must stay in
// sync with the backend, which re-implements them in establishmentController.
export interface NbEtabBucket {
    value: string;
    label: string;
    sub: string;
    min: number;
    max: number;
}

export const NB_ETAB_BUCKETS: NbEtabBucket[] = [
    { value: 'mono',     label: 'Mono-établissement', sub: '1',        min: 1,   max: 1 },
    { value: 'petit',    label: 'Petit groupe',       sub: '2 – 5',    min: 2,   max: 5 },
    { value: 'regional', label: 'Groupe régional',    sub: '6 – 20',   min: 6,   max: 20 },
    { value: 'national', label: 'Groupe national',    sub: '21 – 100', min: 21,  max: 100 },
    { value: 'grand',    label: 'Grand groupe',       sub: '100+',     min: 101, max: Infinity },
];

export const ALL_NB_ETAB = NB_ETAB_BUCKETS.map(b => b.value);

/** True when `count` falls in any of the selected buckets. An empty selection means
 *  "no constraint", so nothing is singled out and this returns false for every count. */
export function countMatchesNbEtab(count: number | undefined, buckets: string[]): boolean {
    if (count === undefined || buckets.length === 0) return false;
    return NB_ETAB_BUCKETS.some(b => buckets.includes(b.value) && count >= b.min && count <= b.max);
}
